import React, {useContext} from 'react'
import {usePopstateListener} from '@components/common/popup/use-popstate-listener'
import {useGlobalKeyDown} from '@containers/hooks'
import {CloseIcon} from './close-icon'
import {
  TwContainer,
  TwFooter,
  TwMoveToBody,
  TwWnd,
  TwWndContent
} from './containers'
import {popupCloseSubscriptions, PropsContext} from './context'
import {PopupContent} from './popup-content'
import {PopupHeader} from './popup-header'
import {PopupProps} from './types'

export const PopupFull = (props: PopupProps) => {
  return (
    <PropsContext.Provider value={props}>
      <PopupFullBase />
    </PropsContext.Provider>
  )
}

export const PopupFullBase = () => {
  const props = useContext(PropsContext)
  const {
    title,
    close,
    footer,
    className,
    paddings = 12,
    popupInWnd = false
  } = props

  const closeWithSubs = (): boolean => {
    if (close) {
      close?.()

      Object.values(popupCloseSubscriptions).forEach(f => f())

      return true
    }
    return false
  }

  useGlobalKeyDown({escape: () => closeWithSubs()})

  usePopstateListener(closeWithSubs)

  const content = (
    <TwContainer>
      <TwWnd>
        <TwWndContent>
          <PopupHeader paddings={paddings} title={title} />
          <PopupContent paddings={paddings} />
          {!!footer && <TwFooter>{footer}</TwFooter>}
        </TwWndContent>
        <CloseIcon onClick={closeWithSubs} />
      </TwWnd>
    </TwContainer>
  )

  if (popupInWnd) {
    return <>{content}</>
  }

  return <TwMoveToBody className={className}>{content}</TwMoveToBody>
}
